export const wait = (time) => {
	return new Promise((res) => setTimeout(res, time));
};

let waitSingletonHandle = null;

export const waitSingleton = (time) => {

    if (waitSingletonHandle) {
        resetWaitSingleton();
     }

	return new Promise((res) => {
        waitSingletonHandle = setTimeout(res, time)
    });
};

export const hasWaitSingleton = () => {
    return waitSingletonHandle != null;
}

export const resetWaitSingleton = () => {
    clearTimeout(waitSingletonHandle);
    waitSingletonHandle = null;
}